import { Link } from '@components/Link'
import type { AppLocales } from '@constants/i18n'
import { APP_LOCALES } from '@constants/i18n'
import { ANDROID, IOS } from '@constants/appStores'
import { arrayIncludes } from '@helpers/arrayIncludes'
import { useGetLocale } from '@hooks/useGetLocale'
import { ResponsiveImage } from '@components/ResponsiveImage'

type Platform = 'android' | 'ios'
type FooterStoreIconProps = {
  image?: {
    url?: string | null
    description?: string | null
    width?: number | null
    height?: number | null
  } | null
  platform: Platform
}

function getStoreURL(platform: Platform, locale?: AppLocales) {
  const isAndroid = platform === 'android'

  if (arrayIncludes(APP_LOCALES, locale)) {
    return isAndroid ? ANDROID[locale] : IOS[locale]
  }

  return isAndroid ? ANDROID.universal : IOS.universal
}

export const FooterStoreIcon = ({ image, platform }: FooterStoreIconProps) => {
  const locale = useGetLocale()

  if (!image?.url) {
    return null
  }

  const appStoreUrl = getStoreURL(platform, locale)

  return (
    <Link url={appStoreUrl} target='_blank'>
      <ResponsiveImage
        originalWidth={image.width}
        originalHeight={image.height}
        sources={[{ breakpoint: 0, width: 120, src: image.url }]}
        alt={image?.description || ''}
      />
    </Link>
  )
}
